// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Atividade',
    ActivityActualBilling: 'Atividade faturável',
    ActivityActualCompletionDateCondition_Text: 'Data de conclusão real da atividade',
    ActivityActualCost: 'Custo real da atividade',
    ActivityActualGreaterThanEstimated_Text: 'Atividades subestimadas',
    ActivityActualHours: 'Horas reais da atividade',
    ActivityActualLaborBilling: 'Trabalho faturável real da atividade ',
    ActivityActualLaborCost: 'Custo de mão de obra real da atividade',
    ActivityBillableHours: 'Horas faturáveis da atividade',
    ActivityBilled: 'Atividade faturada',
    ActivityBilledLabor: 'Trabalho faturado da atividade',
    ActivityBilledPercentage: 'Atividade faturada, %',
    ActivityBudgetVariance: 'Variação do orçamento da atividade',
    ActivityCreationDateCondition_Text: 'Data de criação da atividade',
    ActivityCreator_Text: 'Criadores da atividade',
    ActivityCreatorCondition_Empty_Text: 'Sistema',
    ActivityCreatorCondition_Text: 'Criador da atividade',
    ActivityCustomFieldCondition_Text: 'Campos personalizados da atividade',
    ActivityDuration: 'Duração da atividade',
    ActivityEACBillableExpenses: 'Despesas faturáveis EAC da atividade',
    ActivityEACBilling: 'Faturamento EAC da atividade',
    ActivityEACCost: 'Custo EAC da atividade',
    ActivityEACExpenses: 'Despesas EAC da atividade',
    ActivityEACLaborBilling: 'Trabalho faturável EAC da atividade',
    ActivityEACLaborCost: 'Custo de mão de obra EAC da atividade',
    ActivityEACNonBillableExpenses: 'Despesas não faturáveis EAC da atividade',
    ActivityEndDateCondition_Text: 'Data de término da atividade',
    ActivityEstimatedExpensesAmount: 'Despesas ETC da atividade',
    ActivityEstimatedExpensesBillableAmount: 'Despesas faturáveis ETC da atividade',
    ActivityEstimatedExpensesNonBillableAmount: 'Despesas não faturáveis ETC da atividade',
    ActivityEstimatedHours: 'Horas estimadas da atividade',
    ActivityETCBilling: 'Faturamento ETC da atividade',
    ActivityETCCost: 'Custo ETC da atividade',
    ActivityETCLaborBilling: 'Trabalho faturável ETC da atividade',
    ActivityETCLaborCost: 'Custo de mão de obra ETC da atividade',
    ActivityExpectedProfit: 'Lucro esperado da atividade',
    ActivityExpectedProfitPercentage: 'Lucro esperado da atividade, %',
    ActivityExpensesAmount: 'Despesas reais da atividade',
    ActivityExpensesBillableAmount: 'Despesas faturáveis reais da atividade',
    ActivityExpensesBilledAmount: 'Despesas faturadas da atividade',
    ActivityExpensesNonBillableAmount: 'Despesas não faturáveis reais da atividade',
    ActivityHealthCondition_Text: 'Saúde da atividade',
    ActivityHealthTypes: 'Saúde da atividade',
    ActivityIsMilestone: 'Atividade é marco',
    ActivityNonBillableHours: 'Horas não faturáveis da atividade',
    ActivityProcessCondition_Text: 'Progresso da atividade',
    ActivityProfit: 'Lucro da atividade',
    ActivityProfitPercentage: 'Lucro da atividade, %',
    ActivityProgress_Text: 'Progresso da atividade',
    ActivityStartDateCondition_Text: 'Data de início da atividade',
    ActivityStatusCondition_Text: 'Status da atividade',
    ActivityTotalBudget: 'Orçamento total da atividade',
    ActivityTypeCondition_Text: 'Tipo de atividade:',
    ActivityTypes_Issue: 'Questão',
    ActivityTypes_Request: 'Pedido',
    ActivityTypes_Task: 'Tarefa',
    ActivityTypesCondition_Text: 'Tipos de atividade',
    ActualCompletionDate_Text: 'Data de conclusão real',
    add_filters: 'Adicionar filtros',
    AdvancedFilterTooltipContent_Text: 'Clique aqui para ver todas as opções de filtragem possíveis',
    AdvancedFilterTooltipTitle_Text: 'Filtros avançados',
    AllActivities_Text: 'Atividades',
    Apply_Text: 'Aplicar',
    AssigneeCondition_Text: 'Responsáveis pela atividade',
    AssigneeOption_Text: 'Responsáveis pela atividade',
    AssigneeTeamCondition_Entity: 'times',
    AssigneeUserCondition_Empty_Text: 'Sem responsáveis',
    AssigneeUserCondition_Entity: 'responsáveis pela atividade',
    BoolCustomField_No_Text: 'Não',
    BoolCustomField_NotSelected_Text: 'Não selecionado',
    BoolCustomField_Yes_Text: 'Sim',
    BudgetAndCosts_Filters_Group: 'Orçamento e custos',
    CategoriesCondition_Text: 'Categorias',
    CategoryCondition_Empty_Text: 'Sem categoria',
    CategoryCondition_Entity: 'categorias',
    CategoryCondition_Text: 'Categoria',
    Clear_All_Text: 'Limpar todos os filtros',
    CompletedStatus_Text: 'Concluído',
    constraints_filters_group: 'Restrições',
    ContainMore_Text: 'Existem mais resultados, continue digitando...',
    CreationDate_Text: 'Data de criação',
    CustomerCondition_Empty_Text: 'Sem cliente',
    CustomerCondition_Entity: 'clientes',
    CustomerCondition_Text: 'Clientes',
    CustomFieldsFilters_Group: 'Campos personalizados',
    DraftCondition_Text: 'Rascunhos',
    DraftStatus_Text: 'Rascunhos',
    EndDate_Text: 'Data de término',
    FilterByKeyword_Text: 'Filtrar por palavra-chave',
    FilterByPeriod_Text: 'Filtrar por período',
    FilterByTimeframe_Text: 'Filtrar por período de tempo',
    FilterTabs_Tab1: 'Status',
    FilterTabs_Tab2: 'Recursos e restrições',
    FilterTabs_Tab3: 'Saúde e Progresso',
    FilterTabs_Tab4: 'Projetos, clientes e mais',
    FilterTabs_Tab5: 'Campos personalizados',
    Followed: 'Seguindo',
    FollowedByMe_Text: 'Atividades seguidas por mim',
    From_Text: 'de',
    general: 'Geral',
    HealthCondition_Text: 'Saúde',
    HealthItemType_Bad: 'Problema',
    HealthItemType_Good: 'Bom',
    HealthItemType_Medium: 'Em risco',
    HealthItemType_NotCalculated: 'Não calculado',
    HealthTooltip_Text: 'Saúde é um índice calculado que mostra o andamento de um projeto ou atividade',
    HealthTooltipLink_Text: 'Veja mais em nossa ajuda online',
    HoursCondition_Text: 'Tempo',
    HoursFilters_Group: 'Tempo',
    HoursLeft: 'Horas restantes',
    InProgressStatus_Text: 'Em andamento',
    InThePast: 'No passado',
    InvalidDate: 'A data deve estar no formato \'{0}\'.',
    Issue_Text: 'Questão',
    KeepTyping_Text: 'Continue digitando...',
    ListCustomFieldCondition_Empty_Text: 'Não selecionado',
    ManualRange: 'Intervalo de datas especificado...',
    Me: 'Eu',
    Menu_Dates: 'Datas',
    Milestone_Text: 'Marco',
    MoneyCondition_Text: 'Dinheiro',
    More_Text: 'Mais',
    MultiSelectCustomFieldCondition_Empty_Text: 'Não selecionado',
    NextMonth: 'Próximo mês',
    NextWeek: 'Próxima semana',
    no_filters: 'Nenhum filtro para exibir',
    NoCategory: 'Sem categoria',
    NoMatch_Text: 'Desculpe, nada foi encontrado',
    OnHoldStatus_Text: 'Em espera',
    PeopleCondition_Text: 'Pessoas',
    PinTooltip_Text: 'Fixar',
    Portfolio_Status_Text: 'Status do portfólio',
    PortfolioCondition_Empty_Text: 'Nenhum portfólio',
    PortfolioCondition_Entity: 'portfólios',
    PortfolioCondition_Text: 'Portfólios',
    PortfolioCreator_Text: 'Criadores de portfólio',
    PortfolioCreatorCondition_Text: 'Criador de portfólio',
    PortfolioManager_Text: 'Gerentes de portfólio',
    PortfolioManagerCondition_Text: 'Gerente de portfólio',
    PreviousMonth: 'Mês anterior',
    PreviousWeek: 'Semana anterior',
    PreviousYear: 'Ano anterior',
    PriorityCondition_Text: 'Prioridades',
    Progress_Filters_Group: 'Progresso',
    ProgressCondition_Entity: 'Progresso: ',
    ProgressCondition_Text: 'Progresso',
    Project_Text: 'Projeto',
    ProjectActualBilling: 'Cobrança do projeto',
    ProjectActualCompletionDateCondition_Text: 'Data de conclusão real do projeto',
    ProjectActualCost: 'Custo real do projeto',
    ProjectActualGreaterThanEstimated_Text: 'Projetos subestimados',
    ProjectActualHours: 'Horas reais do projeto',
    ProjectActualLaborBilling: 'Custo real da mão de obra faturável do projeto',
    ProjectActualLaborCost: 'Custo real da mão de obra do projeto',
    ProjectBillableHours: 'Horas faturáveis do projeto',
    ProjectBilled: 'Cobrado do projeto',
    ProjectBilledLabor: 'Mão de obra cobrada do projeto',
    ProjectBilledPercentage: 'Cobrado do projeto, %',
    ProjectBudgetVariance: 'Variação do orçamento do projeto',
    ProjectCondition_EmptyText: 'Nenhum projeto selecionado',
    ProjectCondition_Entity: 'projetos',
    ProjectCondition_Text: 'Projetos',
    ProjectCostExceedBudget_Text: 'Projetos com orçamento excedido',
    ProjectCreationDateCondition_Text: 'Data de criação do projeto',
    ProjectCreator_Text: 'Criadores de projeto',
    ProjectCreatorCondition_Text: 'Criador de projeto',
    ProjectCustomFieldCondition_Text: 'Campos personalizados do projeto',
    ProjectDuration: 'Duração do projeto',
    ProjectEACBillableExpenses: 'Despesas faturáveis EAC do projeto',
    ProjectEACBilling: 'Faturamento EAC do projeto',
    ProjectEACCost: 'Custo EAC do projeto',
    ProjectEACExpenses: 'Despesas EAC do projeto',
    ProjectEACLaborBilling: 'Custo da mão de obra faturável EAC do projeto',
    ProjectEACLaborCost: 'Custo da mão de obra EAC do projeto',
    ProjectEACNonBillableExpenses: 'Despesas não faturáveis EAC do projeto',
    ProjectEndDateCondition_Text: 'Data de término do projeto',
    ProjectEstimatedExpensesAmount: 'Despesas ETC do projeto',
    ProjectEstimatedExpensesBillableAmount: 'Despesas faturáveis ETC do projeto',
    ProjectEstimatedExpensesNonBillableAmount: 'Despesas não faturáveis ETC do projeto',
    ProjectEstimatedHours: 'Horas estimadas do projeto',
    ProjectETCBilling: 'Faturamento ETC do projeto',
    ProjectETCCost: 'Custo ETC do projeto',
    ProjectETCLaborBilling: 'Custo da mão de obra faturável ETC do projeto',
    ProjectETCLaborCost: 'Custo da mão de obra ETC do projeto',
    ProjectExpectedProfit: 'Lucro esperado do projeto',
    ProjectExpectedProfitPercentage: 'Lucro esperado do projeto, %',
    ProjectExpensesAmount: 'Despesas reais do projeto',
    ProjectExpensesBillableAmount: 'Despesas faturáveis reais do projeto',
    ProjectExpensesBilledAmount: 'Despesas cobradas do projeto',
    ProjectExpensesNonBillableAmount: 'Despesas não faturáveis reais do projeto',
    ProjectHealthCondition_Text: 'Saúde do projeto',
    ProjectHealthTypes: 'Tipos de saúde do projeto',
    ProjectManager_Text: 'Gerentes de projeto',
    ProjectManagerCondition_Text: 'Gerente de projeto',
    ProjectMemberCondition_Text: 'Membro do projeto',
    ProjectNonBillableHours: 'Horas não faturáveis do projeto',
    ProjectPriorityCondition_Text: 'Prioridade do projeto',
    ProjectPriorityCondition_Text_Template: 'Projetos com prioridade %s',
    ProjectProcessCondition_Text: 'Progresso do projeto',
    ProjectProfit: 'Lucro do projeto',
    ProjectProfit_Text: 'Projetos com prejuízo financeiro',
    ProjectProfitPercentage: 'Lucro do projeto, %',
    ProjectProgress_Text: 'Progresso do projeto',
    ProjectsAndTasksList_Title: 'Projetos e tarefas',
    ProjectsCustomersAndMore_Filters_Group: 'Projetos, clientes e mais',
    ProjectStartDateCondition_Text: 'Data de início do projeto',
    ProjectStatusCondition_Text: 'Status do projeto',
    ProjectTotalBudget: 'Orçamento total do projeto',
    QuickFilterWatermark: 'Filtrar por...',
    range_condition_text: 'Intervalo',
    Request_Text: 'Pedido',
    resource_types_condition_text: 'Recursos',
    resource_types_planning_condition_text: 'Projetos com recursos',
    resource_types_unnamed_label: 'Recursos sem nome',
    resource_types_user_label: 'Usuários',
    ResourceRequestApprover_Text: 'Aprovador da solicitação de recurso',
    ResourceRequestCreator_Text: 'Criador da solicitação de recurso',
    ResourceRequestStatuses_Approved: 'Aprovado',
    ResourceRequestStatuses_Rejected: 'Rejeitado',
    ResourceRequestStatuses_WaitingForApproval: 'Aguardando aprovação',
    ResourceRequestStatuses_WithoutRequest: 'Sem solicitação',
    ResourceRequestStatusFilter_Text: 'Status da solicitação de recurso',
    resources_filters_group: 'Recursos',
    resources_requests_filters_group: 'Solicitações de recursos',
    ResourcesAndConstraints_Filters_Group: 'Recursos e restrições',
    roles_condition_text: 'Funções',
    RollBack_Text: 'Voltar para filtros anteriores',
    SaveFilters_Title: 'Filtros salvos',
    set_filters: 'Definir filtros usando o',
    set_filters_part2: 'ícone',
    skills_condition_text: 'Habilidades',
    StartDate_Text: 'Data de início',
    Statuses_Filters_Group: 'Status',
    StatusesCountFormat: '1#{0} status#{0} statusos',
    Task_Text: 'Tarefa',
    TaskCondition_Entity: 'atividades',
    TaskCondition_Text: 'Atividade',
    TaskCostExceedBudget_Text: 'Atividades com custo excedente',
    TaskPriorityCondition_Entity: 'prioridades de atividade',
    TaskPriorityCondition_Text: 'Prioridade da atividade',
    TaskPriorityCondition_Text_Template: 'Atividades com prioridade %s',
    TasksAssignedToMilestone_Text: 'Atividade atribuída ao marco',
    teams_condition_text: 'Equipes',
    TemplateCondition_Text: 'Modelos',
    TemplateStatus_Text: 'Modelos',
    ThisMonth: 'Este mês',
    ThisWeek: 'Esta semana',
    ThisYear: 'Este ano',
    To_Text: 'para',
    Today: 'Hoje',
    TypesCondition_Text: 'Tipos',
    UnpinTooltip_Text: 'Desfixar',
    users_condition_text: 'Usuários',
    Yesterday: 'Ontem',
};
